// The compass D-pad look (small glass circles, gold centre), reusable. Same
// geometry as CompassView's pad, drawn at the same 0.62 scale.
import React from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { GlassFill } from './ui';
import { makeStyles } from './theme';

const DPAD = 132;
const BTN = 42;

export function DPad({
  onUp,
  onDown,
  onLeft,
  onRight,
  onCenter,
  centerGlyph,
  style,
}: {
  onUp: () => void;
  onDown: () => void;
  onLeft: () => void;
  onRight: () => void;
  onCenter: () => void;
  centerGlyph: string;
  style?: object;
}) {
  const styles = useStyles();
  const btn = (pos: object, glyph: string, onPress: () => void, gold = false) => (
    <Pressable onPress={onPress} style={[styles.btn, pos, gold && styles.gold]} hitSlop={4}>
      <View style={[StyleSheet.absoluteFill, { borderRadius: BTN / 2, overflow: 'hidden' }]} pointerEvents="none">
        <GlassFill radius={BTN / 2} tone={gold ? 'gold' : 'glass'} />
      </View>
      <Text style={gold ? styles.goldText : styles.text}>{glyph}</Text>
    </Pressable>
  );
  const c = DPAD / 2 - BTN / 2;
  return (
    <View pointerEvents="box-none" style={[styles.pad, { transform: [{ scale: 0.62 }] }, style]}>
      {btn({ top: 0, left: c }, '▲', onUp)}
      {btn({ bottom: 0, left: c }, '▼', onDown)}
      {btn({ left: 0, top: c }, '◀', onLeft)}
      {btn({ right: 0, top: c }, '▶', onRight)}
      {btn({ top: c, left: c }, centerGlyph, onCenter, true)}
    </View>
  );
}

const useStyles = makeStyles((t) =>
  StyleSheet.create({
    pad: { position: 'absolute', width: DPAD, height: DPAD, zIndex: 5 },
    btn: { position: 'absolute', width: BTN, height: BTN, borderRadius: BTN / 2, borderWidth: StyleSheet.hairlineWidth, borderColor: t.navyLine, alignItems: 'center', justifyContent: 'center', boxShadow: `0 4px 14px ${t.glowSoft}`, outlineStyle: 'none' } as object,
    gold: { borderColor: t.goldBright, boxShadow: `0 0 16px ${t.goldGlow}` } as object,
    text: { fontSize: 18, color: t.ivory, fontWeight: '900' },
    goldText: { fontSize: 13, color: t.onGold, fontWeight: '900' },
  }),
);
